<template>
  <div class="row">
    <div class="col-md-4 col-sm-6">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a href="/client/lms" v-bind="attrs" v-on="on">
            <img
              width="100%"
              src="https://i.imgur.com/BBHlmNt.jpg"
              class="img-fluid"
              alt="Course Library"
            />
          </a>
        </template>
        <span>
          Start learning today!<br />
          Go to your Course Library to watch thousand of videos <br />
          to learn how to be a better salesperson.
        </span>
      </v-tooltip>
    </div>
    <div class="col-md-4 col-sm-6">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a href="/client/shops" v-bind="attrs" v-on="on">
            <img
              width="100%"
              src="https://i.imgur.com/07Ms1U9.jpgg"
              class="img-fluid"
              alt="Mystery Shopping"
            />
          </a>
        </template>
        <span>
          See how your dealer performed against your competitors <br />
          with our comprehensive mystery shopping data.
        </span>
      </v-tooltip>
    </div>
    <!-- <div class="col-md-3 col-sm-6">
      <a href="/secretshop/competitors/logs">
        <img
          width="100%"
          src="https://i.imgur.com/KKZ1LXg.jpg"
          class="img-fluid"
          alt="Nationwide Competitors"
        />
      </a>
    </div> -->
    <div class="col-md-4 col-sm-6">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a
            href="/clients/file-manager"
            target="_blank"
            v-bind="attrs"
            v-on="on"
          >
            <img
              width="100%"
              src="https://i.imgur.com/no4xTba.jpg"
              class="img-fluid"
              alt="File Manager"
            />
          </a>
        </template>
        <span>
          Download call guides and best practices<br />
          from your file manager.
        </span>
      </v-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TopWidget',
};
</script>
